var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-tab"},[_c('h3',[_vm._v("Settings")]),_c('p',[_vm._v("Settings configuration will be available soon.")])])
}]

export { render, staticRenderFns }